import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

const CHARACTERS_BASE = "/(nav)/(app)/browse/(browse-tabs)/characters" as const;

/** Characters tab entry — resolves to the folder index, which redirects to the Rank route. */
function useCharactersNavigator() {
  return useCallback(
    () => ({
      href: { pathname: CHARACTERS_BASE },
      queries: [],
    }),
    [],
  );
}

export const useBrowseCharactersPageNavigator = createPageNavigator<void>({
  useNavigator: useCharactersNavigator,
});

function useCharactersRankNavigator() {
  return useCallback(
    () => ({
      href: { pathname: `${CHARACTERS_BASE}/rank` },
      queries: [],
    }),
    [],
  );
}

export const useBrowseCharactersRankPageNavigator = createPageNavigator<void>({
  useNavigator: useCharactersRankNavigator,
});
